import { atom } from 'nanostores'
import type { ReminderLeadDays } from '~/features/multi-page/lib/trial-reminder'

/**
 * The reminder lead time the user picked on the Variant1 selection page.
 * In-memory only — not URL-backed, not persisted: a reload between the
 * reminder page and the purchase loses it, and native's default then stands.
 */
export const $reminderLeadDays = atom<ReminderLeadDays | null>(null)
